import styled from 'styled-components';

import {Section} from '~/shared/components/OrderCompleteSections/parts';
import {paddingCss} from '~/shared/components/OrderCompleteSections/orderSummaryStyle';
import {getLocalizationService} from '~/shared/services/localisationService';
import {UserVoucher} from '~/shared/store/models/User/UserVouchers';
import {body14Bold, body16Normal} from '~/shared/theme/typography';
import {getIsFreeFitVendor, getVendorDisclaimer} from '~/shared/utils/barcode';
import {FlexCenter, FlexCenterHorizontally} from '~/shared/theme/FlexLayout';
import {CopyToClipboardButton} from '~/shared/components/CopyToClipboardButton';

const BarCodeSection = styled(Section)`
  padding-top: 32px;
  ${paddingCss}
  background: ${({theme}) => theme.colors.surface};
`;

const BarcodeWrapper = styled(FlexCenterHorizontally)`
  width: 100%;
  flex-direction: column;
`;

const BarCodeImg = styled.div.attrs(({imageUrl}: {imageUrl?: string}) => ({
  style: {backgroundImage: imageUrl && `url(${imageUrl})`},
}))<{imageUrl?: string}>`
  background-position: center;
  height: 69px;
  margin: auto;
  background-size: contain;
  background-repeat: no-repeat;
  width: 193px;
`;

const BarCodeNumber = styled.div`
  margin: auto;
  text-align: center;
  ${body16Normal}
  padding-top: 13px;
  color: ${({theme}) => theme.colors.secondary};
  background: ${({theme}) => theme.colors.surface};
`;

const BoldInfoText = styled.div`
  ${body14Bold}
`;

const InfoText = styled.div`
  max-width: 416px;
  width: auto;
  margin: 0 auto;
`;

const ExplanationText = styled.div<{isFreefit?: boolean}>`
  ${({isFreefit}) => !isFreefit && 'text-align: center;'}
  padding: 18px 0 10px 0;
  color: ${({theme}) => theme.colors.secondary};
  background: ${({theme}) => theme.colors.surface};
  width: 100%;
`;

const CopyToClipboardWrapper = styled(FlexCenter)`
  width: 100%;
`;

type OrderSummaryBarcodeProps = {
  barcode: UserVoucher;
  isGov: boolean;
};

const OrderSummaryBarcode = ({barcode, isGov}: OrderSummaryBarcodeProps) => {
  const {t} = getLocalizationService();

  const isFreefit = getIsFreeFitVendor(barcode.vendor);

  return (
    <BarCodeSection>
      {isFreefit ? (
        <CopyToClipboardWrapper>
          <CopyToClipboardButton textToCopy={barcode.barCodeNumber}>{barcode.barCodeNumber}</CopyToClipboardButton>
        </CopyToClipboardWrapper>
      ) : (
        <BarcodeWrapper>
          <BarCodeImg data-test-id="orderSummaryBarcodeImage" imageUrl={barcode.barCodeImgUrl} />
          <BarCodeNumber data-test-id="orderSummaryBarcodeNumber">{barcode.barCodeNumber}</BarCodeNumber>
        </BarcodeWrapper>
      )}
      <ExplanationText isFreefit={isFreefit}>
        {!isFreefit && <BoldInfoText>{t('bar_code_must_be_printed')}</BoldInfoText>}
        <InfoText>{getVendorDisclaimer(barcode?.vendor, isGov)}</InfoText>
      </ExplanationText>
    </BarCodeSection>
  );
};

export default OrderSummaryBarcode;
